var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component } from 'vue-property-decorator';
import PauseApply from '~/components/apply-component/pause-apply.vue';
import { namespace } from "vuex-class";
import { ApplyType, CASE_HALT_CATEGORY } from "~/config/enum.config";
var CollectionExecutionModule = namespace("collection-execution");
var PauseButton = /** @class */ (function (_super) {
    __extends(PauseButton, _super);
    function PauseButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dialog = false;
        _this.applyType = {};
        _this.otherModel = {
            caseHaltCategory: CASE_HALT_CATEGORY.CASE_HALT
        };
        return _this;
    }
    PauseButton.prototype.onClickButton = function () {
        this.applyType = ApplyType.pause;
        this.dialog = true;
    };
    __decorate([
        CollectionExecutionModule.State
    ], PauseButton.prototype, "caseId", void 0);
    PauseButton = __decorate([
        Component({
            components: {
                PauseApply: PauseApply
            }
        })
    ], PauseButton);
    return PauseButton;
}(Vue));
export default PauseButton;
